import React from 'react';
import Sidebar from '../../components/common/Sidebar';
import Navbar from '../../components/common/Navbar';
import LeaveRequestForm from '../components/forms/LeaveRequestForm';
import '../../wrms/css/wrms.css';

const LeaveRequestPage = () => (
  <div className="d-flex wrms-page">
    <Sidebar />
    <div className="flex-grow-1">
      <Navbar />
      <div className="wrms-container">
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="wrms-page-header">
            <div className="wrms-breadcrumb">Leave Management · <span>Leave Request</span></div>
            <h1 className="wrms-page-title">Apply for Leave</h1>
            <p className="wrms-page-subtitle">Submit a new leave request. It will be routed for approval based on your department.</p>
          </div>
          <div className="wrms-card" style={{ overflow: 'hidden' }}>
            <LeaveRequestForm />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default LeaveRequestPage;
